module.exports = __webpack_public_path__ + "static/06-usertesting-small-7304fa0a3b8bc06c001c10fed830b126.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/06-usertesting-small.jpg
// module id = 2646
// module chunks = 35783957827783